// *******************************************************************************
// Form handling
// *******************************************************************************

const handleForm = (form, formAction, formSubAction) => {
  const formParent = form.closest('[data-parent]');
  const submitBtn = form.querySelector('.form-component__submit .btn');

  if (!formParent) {
    return;
  }
  const parentSection = form.closest('.sc-general');
  const formAlertError = formParent.querySelector('.form-component__alert-error');

  const emailError = getEmailError(form);
  const emailFields = formParent.querySelectorAll('input[type="email"]'); // Get all email fields

  const fieldValidators = {};
  emailFields.forEach((field) => {
    const fieldName = field.name;

    if (fieldName) {
      fieldValidators[fieldName] = {
        validators: {
          callback: {
            message: emailError,
            callback(input) {
              return validateEmail(input.value);
            },
          },
        },
      };
    }
  });

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: fieldValidators,
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) =>
          element.closest('.mod-input,.checkbox,.dropdown,.radio-button,.upload-box,.form-component__item'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input, .checkbox, .dropdown, .radio-button,.upload-box,.form-component__item',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      const formType = form.querySelector('[data-form-type]').value;
      const formValue = getFormValue(form, fv);

      // pushToDataLayer({
      //   event: 'form_submit',
      //   form_info: {
      //     form_id: formType,
      //     form_name: formType,
      //   },
      //   form_fields: JSON.parse(formValue.inputs.replaceAll(`${formType.replaceAll('-', '_')}_`, '')),
      // });

      grecaptcha.ready(async () => {
        submitBtn.disabled = true;
        formParent.classList.add('show-loader');
        try {
          const files = {};

          Object.values(filesToUpload).forEach((filesArray) => {
            const inputName = filesArray[0]?.inputName;
            if (!inputName) return;

            files[inputName] = [];

            filesArray.forEach((fileObj) => {
              files[inputName].push(fileObj.file);
            });
          });

          // Array.from(filesToUpload).forEach((file, index) => {
          //   const filesArray = filesToUpload[index];
          //   files[`files_${index + 1}`] = file.file;
          // });

          await onFormSubmit({
            formData: {
              ...formValue,
              ...files,
              id: localData.id,
              lang: localData.lang,
              formType,
              formSubAction,
              houseSlug: form.querySelector('[data-house-slug]')?.value,
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: formAction,
          });

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');

          if (parentSection) {
            parentSection.classList.add('show-thankyou');
            const scrollPosition = parentSection.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth',
            });
          }
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
        submitBtn.disabled = false;
      });
    });
};

document.addEventListener('DOMContentLoaded', () => {
  [
    'form_component',
    'check_status',
    'enrollment_form',
    'newsletter_form',
    'contact_form',
    'order_form',
    'event_form',
    'technical_help_form',
    'water_outage_form',
  ].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      const formSubAction = form.querySelector('[data-sub-action]')?.value || '';
      handleForm(form, formAction, formSubAction);
    }
  });
});

// Check if all inputGroups in group have same name
const inputGroupParents = document.querySelectorAll('[data-input-group-parent]');

inputGroupParents.forEach((formRow) => {
  const inputGroups = formRow.querySelectorAll('[data-input-group-field]');

  if (inputGroups.length > 1) {
    // Check if failed
    const observer = new MutationObserver(() => {
      const inputParents = formRow.querySelectorAll('[data-input-group-item]');
      const hasFailedRadio = [...inputParents].some((inputParent) =>
        inputParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedRadio);
    });

    inputGroups.forEach((input) =>
      observer.observe(input.closest('[data-input-group-item]'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div
    if (formRow.classList.contains('input-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.appendChild(groupErrorMessage);
      }
    }
  }
});

document.querySelectorAll('[data-toggle-field]').forEach((radio) => {
  const groupName = radio.name;
  const target = document.querySelector(`[data-field="${radio.dataset.toggleField}"]`);

  if (!target) return;

  const update = () => {
    const checkedRadio = document.querySelector(`[name="${groupName}"]:checked`);
    target.classList.toggle('hide', checkedRadio !== radio);
  };

  document.querySelectorAll(`[name="${groupName}"]`).forEach((r) => r.addEventListener('change', update));
  update();
});
